<template lang='haml'>
  .admin-orders
    %v-layout.row
      %v-flex.mb-5
        %filter-bar{ ":search": "search", "@filterOrders": "filterOrders($event)", "@search": "searchFor($event)" }
    .orders-list
      %v-layout.row
        %v-flex.xs12
          %table.fancy.white-background
            %thead
              %tr
                %th.line-num
                %th.left-align.nowrap{ width: '1' } Order #
                %th.left-align.hidden-sm-and-down{ width: '95px' } Started
                %th.left-align.hidden-sm-and-down{ width: '95px' } Ordered
                %th.left-align.hidden-sm-and-down{ width: '95px' } Production
                %th.left-align.hidden-md-and-down{ width: '95px' } Shipped
                %th.left-align.hidden-md-and-down{ width: '95px' } Delivered
                %th.left-align.nowrap Items
                %th.left-align.nowrap.hidden-md-and-down{ width: '1' } Qty
                %th.left-align.nowrap.hidden-md-and-down{ width: '200' } Ship To
                %th.left-align.nowrap.hidden-md-and-down{ width: '200' } Bill To
                %th.center-align{ width: '1' } Actions
            %tbody
              %tr{ "v-if": "orders.length <= 0" }
                %td.line-num
                %td.center-align{ colspan: 11 }
                  No orders found.
              %tr{ "v-else": "", "v-for": "(order, index) in orders" }
                %td.line-num {{index + 1}}
                %td.nowrap
                  %v-tooltip{ bottom: true }
                    %a{ slot: "activator", ":href": "'/orders/' + order.id", target: '_blank' } {{order.site_code}}{{order.id}}
                    %span Order Process: {{order.process || 'None'}}
                  %br
                  %span.allcaps{ slot: "activator", ":href": "'/admin/users/' + order.user_id" } {{order.affiliate_id || order.site_code}}
                  %v-tooltip{ bottom: true }
                    %a{ slot: "activator", ":href": "'/admin/users/' + order.user_id" } {{order.user_id}}
                    %span {{order.email}}
                %td.center-align.nowrap.hidden-sm-and-down
                  .caption{ "v-if": "order.created_at" }
                    %span {{order.created_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY')}}
                    %br
                    %span {{displayTime(order.created_at)}}
                %td.center-align.nowrap.hidden-sm-and-down
                  .caption{ "v-if": "order.ordered_at" }
                    %span {{order.ordered_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY')}}
                    %br
                    %span {{displayTime(order.ordered_at)}}
                %td.center-align.nowrap
                  .caption{ "v-if": "order.processed_at" }
                    %span {{order.processed_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY')}}
                    %br
                    %span {{displayTime(order.processed_at)}}
                %td.center-align.nowrap.hidden-md-and-down
                  %template{ "v-if": "shouldHaveShipped(order)" }
                    %v-icon{ color: "red" } mdi-alert
                    .caption {{order.expected_to_ship | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY')}}
                  .caption{ "v-else-if": "order.shipped_at" }
                    %span {{order.shipped_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY')}}
                    %br
                    %span {{displayTime(order.shipped_at)}}
                  .caption{ "v-else-if": "order.processed_at" }
                    Exp Ship
                    %br
                    %span {{order.expected_to_ship | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY')}}
                %td.center-align.nowrap.hidden-md-and-down
                  .caption{ "v-if": "order.delivered_at" }
                    %span {{order.delivered_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY')}}
                    %br
                    %span {{displayTime(order.delivered_at)}}
                  .caption{ "v-else-if": "order.expected_at" }
                    Exp Del
                    %br
                    %span {{order.expected_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY')}}

                %td
                  %div.admin-order-items{ "v-for": "item in order.items" }
                    .left.mt-1
                      %v-tooltip{ bottom: true }
                        %a{ slot: "activator", ":href": "item.file.files.preview", target: "_blank" }
                          %img.mr-2.border.v-align.thumbnail{ ":src": "item.file.thumbs.small" }
                        %span {{item.name || 'Unknown'}}
                    %div
                      %div {{(item.name || 'Unknown')}}
                      %detail-modal{ ":item": "item" } Details
                  %span{ "v-if": "order.items.length == 0" }
                    No Items Found
                %td.nowrap.hidden-md-and-down
                  %template{ "v-for": "item in order.items" }
                    .right {{item.quantity}}
                %td.hidden-md-and-down
                  %v-tooltip{ bottom: true, "v-if": "order.customer" }
                    %div{ slot: "activator" }
                      .caption {{fullName(order.shipping_info)}}
                      .caption {{companyName(order.shipping_info)}}
                    %span {{order.customer.ship_add1}}
                    %br{ "v-if": "order.customer.ship_add2" } {{order.customer.ship_add2}}
                    %br {{order.customer.ship_city}}, {{order.customer.ship_state}} {{order.customer.ship_zip}}
                %td.hidden-md-and-down
                  %v-tooltip{ bottom: true, "v-if": "order.customer" }
                    %div{ slot: "activator" }
                      .caption {{fullName(order.billing_info)}}
                      .caption {{companyName(order.billing_info)}}
                    %span {{order.customer.add1}}
                    %br{ "v-if": "order.customer.add2" } {{order.customer.add2}}
                    %br {{order.customer.city}}, {{order.customer.state}} {{order.customer.zip}}
                %td.nowrap.center-align
                  .btn-group
                    %v-tooltip{ bottom: true }
                      %v-btn{ slot: "activator", disabled: true, icon: true }
                        %v-icon mdi-credit-card
                      %span Payment Details
                    %v-tooltip{ bottom: true, "v-if": "order.shipping_status.shipping_link" }
                      %v-btn{ icon: true, slot: "activator", ":href": "order.shipping_status.shipping_link", target: "_blank" }
                        %v-icon fab fa-{{order.shipping_carrier.toLowerCase()}}
                      %span {{order.shipping_method_short_name}}
                    %v-btn{ "v-else": true, disabled: true, icon: true }
                      %v-icon mdi-truck
                    %v-tooltip{ bottom: true, "v-if": "order.processed_at && order.status_id !== 3" }
                      %v-btn{ slot: "activator", "@click": "resubmitOrder(order)", icon: true }
                        %v-icon mdi-redo
                      %span Resubmit Order (Same #)
                    %v-tooltip{ bottom: true, "v-else-if": "order.ordered_at && order.status_id !== 3" }
                      %v-btn{ slot: "activator", "@click": "submitOrder(order)", icon: true }
                        %v-icon mdi-send
                      %span Submit Order
                    %v-btn{ "v-else": true, disabled: true, icon: true }
                      %v-icon mdi-send
                    %v-tooltip{ bottom: true, "v-if": "order.ordered_at" }
                      %v-btn{ slot: "activator", "@click": "replaceOrder(order)", icon: true }
                        %v-icon mdi-autorenew
                      %span Replacement Order (No Cost)
                    %v-btn{ "v-else": true, disabled: true, icon: true }
                      %v-icon mdi-autorenew
                    %v-tooltip{ bottom: true, "v-if": "!order.processed_at && order.status_id !== 3" }
                      %v-btn{ slot: "activator", "@click": "cancelOrder(order)", icon: true }
                        %v-icon mdi-close-circle
                      %span Cancel Order
                    %v-tooltip{ bottom: true, "v-else-if": "order.status_id === 3" }
                      %v-btn{ slot: "activator", "@click": "reinstateOrder(order)", icon: true }
                        %v-icon mdi-restore
                      %span Reinstate Order
                    %v-btn{ "v-else": true, disabled: true, icon: true }
                      %v-icon mdi-close-circle
</template>

<script>
  import api from '@/api/gungho'
  import Events from '@/api/events'
  import DetailModal from '../../widgets/detail-modal'
  import FilterBar from './filter-bar'

  export default {
    metaInfo: {
      title: 'Admin Orders'
    },

    data () {
      return {
        orders: false,
        filter: 'pending',
        search: ''
      }
    },

    components: {
      detailModal: DetailModal,
      filterBar: FilterBar
    },

    methods: {
      displayTime (time) {
        return this.$moment(time).tz('America/Los_Angeles').format('h:mm A [PT]')
        // return this.$moment(time).format('hh:mm A Z')
      },

      orderItemQuantity (items) {
        var total = 0

        for (var i = 0; i < items.length; i++) {
          total += items[i].quantity
        }

        return total
      },

      shouldHaveShipped (order) {
        if (!order.expected_to_ship) return false
        if (order.shipped_at) return false
        return this.$moment().format('YYYYMMDD') > this.$moment('timezone', 'America/Los_Angeles', order.expected_to_ship).format('YYYYMMDD')
      },

      fullName (data) {
        if (data && data.name) {
          return data.name
        } else {
          return ''
        }
      },

      companyName (data) {
        if (data && data.company) {
          return data.company
        } else {
          return ''
        }
      },

      filterOrders (filter) {
        if (filter) this.filter = filter
        if (!this.search) this.search = ''
        if (!this.filter) this.filter = 'pending'
        console.log('Filtering on:', this.filter, 'Searching for:', this.search)
        api.adminOrders({search: this.search, filter: this.filter}).then((data) => {
          this.orders = data.orders
        })
      },

      searchFor (str) {
        console.log('Search For: ', str)
        this.search = str
        this.filterOrders()
      },

      cancelOrder (order) {
        this.$confirm(`Cancel Order ${order.site_code}${order.id}?`).then(confirmed => {
          if (!confirmed) return
          console.log('Canceling order for:', order.id)
          api.cancelOrder(order.id).then((data) => {
            console.log('Order canceled: ', data)
            if (data === true) {
              this.filterOrders()
              Events.$emit('toast', 'Order Canceled')
            } else {
              Events.$emit('error', 'Error Cancelling Order')
            }
          })
        })
      },

      reinstateOrder (order) {
        this.$confirm(`Reinstate Order ${order.site_code}${order.id}?`).then(confirmed => {
          if (!confirmed) return
          console.log('Reinstating order for:', order.id)
          api.reinstateOrder(order.id).then((data) => {
            console.log('Order Reinstated: ', data)
            if (data === true) {
              this.filterOrders()
              Events.$emit('toast', 'Order Reinstated')
            } else {
              Events.$emit('error', 'Error Reinstating Order')
            }
          })
        })
      },

      replaceOrder (order) {
        this.$confirm(`Replace Order ${order.site_code}${order.id}?`).then(confirmed => {
          if (!confirmed) return
          console.log('Replace Order:', order.id)
          api.replaceOrder(order.id).then((data) => {
            if (data === true) {
              this.filterOrders('pending')
              Events.$emit('toast', 'Order Replaced')
            } else {
              Events.$emit('error', 'Error Replacing Order')
            }
          })
        })
      },

      resubmitOrder (order) {
        this.$confirm(`Resubmit Order ${order.site_code}${order.id}?`).then(confirmed => {
          if (!confirmed) return
          console.log('Redo Order:', order.id)
          api.redoOrder(order.id).then((data) => {
            if (data === true) {
              this.filterOrders()
              Events.$emit('toast', 'Order Resubmitted')
            } else {
              Events.$emit('error', 'Error Resubmitting Order')
            }
          })
        })
      },

      submitOrder (order) {
        this.$confirm(`Submit Order ${order.site_code}${order.id}?`).then(confirmed => {
          if (!confirmed) return
          console.log('Redo Order:', order.id)
          api.redoOrder(order.id).then((data) => {
            if (data === true) {
              this.filterOrders()
              Events.$emit('toast', 'Order Submitted')
            } else {
              Events.$emit('error', 'Error Submitting Order')
            }
          })
        })
      }

    },

    beforeMount () {
      if (this.$route.hash) this.filter = this.$route.hash.substring(1)
      this.filterOrders()
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?3663a9e4